import { render, staticRenderFns } from "./L1.vue?vue&type=template&id=13b4e13a&scoped=true&"
import script from "./L1.vue?vue&type=script&lang=js&"
export * from "./L1.vue?vue&type=script&lang=js&"
import style0 from "./L1.vue?vue&type=style&index=0&id=13b4e13a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b4e13a",
  null
  
)

export default component.exports